/**
 * @generated SignedSource<<a7cb8933247fc406f2579aa8fd6b20fa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type administratorLayoutContainerQuery$variables = Record<PropertyKey, never>;
export type administratorLayoutContainerQuery$data = {
  readonly treeMenu: string;
};
export type administratorLayoutContainerQuery = {
  response: administratorLayoutContainerQuery$data;
  variables: administratorLayoutContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "treeMenu",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "administratorLayoutContainerQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "administratorLayoutContainerQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "a38cec031a3d6f8f51370e9de47dcb3f",
    "id": null,
    "metadata": {},
    "name": "administratorLayoutContainerQuery",
    "operationKind": "query",
    "text": "query administratorLayoutContainerQuery {\n  treeMenu\n}\n"
  }
};
})();

(node as any).hash = "08733fbf0a7f26c1151b00893a02b4f3";

export default node;
